var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.53 4.956A1 1 0 0 0 7 5.804v12.392a1 1 0 0 0 1.53.848l9.913-6.196a1 1 0 0 0 0-1.696z"
})));
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNTMgNC45NTYyMUM3Ljg2Mzk1IDQuNTM5OTMgNyA1LjAxODc3IDcgNS44MDQyMVYxOC4xOTU3QzcgMTguOTgxMiA3Ljg2Mzk1IDE5LjQ2IDguNTMgMTkuMDQzN0wxOC40NDMyIDEyLjg0OEMxOS4wNjk5IDEyLjQ1NjMgMTkuMDY5OSAxMS41NDM2IDE4LjQ0MzIgMTEuMTUyTDguNTMgNC45NTYyMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";